import { FilePlus2, SearchX } from 'lucide-react';
import type { ReactElement } from 'react';

import { StatePanel } from '@/components/ui/StatePanel';

interface Props {
  /** La vista está acotada por estado, búsqueda o "+ Filtro". */
  filtered: boolean;
  /** Hay documentos, pero no en esta página (enlace viejo o página fuera de rango). */
  pastEnd: boolean;
  /** Abre el alta; ausente si el rol no puede registrar. */
  onCreate?: () => void;
  onClearFilters: () => void;
  onFirstPage: () => void;
}

/**
 * Lista Maestra sin filas (QA F1 #9): distingue una empresa que todavía no tiene
 * documentos de una vista que ningún documento cumple, y ofrece la salida de cada caso.
 */
export function MasterListEmpty({
  filtered,
  pastEnd,
  onCreate,
  onClearFilters,
  onFirstPage,
}: Props): ReactElement {
  if (pastEnd) {
    return (
      <StatePanel
        icon={<SearchX />}
        title="Esta página ya no tiene documentos"
        role="status"
        className="d2"
      >
        La lista cambió desde que se abrió este enlace.{' '}
        <button type="button" className="btn sm mut" onClick={onFirstPage}>
          Ir a la primera página
        </button>
      </StatePanel>
    );
  }
  if (filtered) {
    return (
      <StatePanel
        icon={<SearchX />}
        title="Ningún documento coincide con los filtros"
        role="status"
        className="d2"
      >
        Ajusta la búsqueda o quita filtros para ver el resto de la lista.{' '}
        <button type="button" className="btn sm mut" onClick={onClearFilters}>
          Limpiar filtros
        </button>
      </StatePanel>
    );
  }
  return (
    <StatePanel
      icon={<FilePlus2 />}
      title="Todavía no hay documentos en esta empresa"
      role="status"
      className="d2"
    >
      {onCreate ? (
        <>
          Registra el primer documento controlado para empezar la Lista Maestra.{' '}
          <button type="button" className="btn sm" onClick={onCreate}>
            Registrar el primer documento
          </button>
        </>
      ) : (
        'Los documentos aparecerán aquí cuando se registren.'
      )}
    </StatePanel>
  );
}
